import { 
    SET_LOADING,
    SET_ALL_JOB_LIST,
    SET_ALL_JOB_LIST_META,
    SET_SHORTLISTED_JOB_LIST,
    SET_SHORTLISTED_JOB_LIST_META,
    SET_APPLIED_JOB_LIST,
    SET_APPLIED_JOB_LIST_META,
    APPEND_ALL_JOB_LIST,
    APPEND_SHORTLISTED_JOB_LIST,
    APPEND_APPLIED_JOB_LIST,
    SET_CURRENT_JOB,
    SET_CURRENT_JOB_META,
    SET_JOB_FILTER,
    SET_SORT_TYPE
} from "../../actions/auditions/types";

const INITIAL_STATE = {
    loading: false,
    allJobList: [],
    allJobListMetaData: {
        loading: false, hasMore: true
    },
    shortlistedJobList: [],
    shortlistedJobListMetaData: {
        loading: false, hasMore: true
    },
    appliedJobList: [],
    appliedJobListMetaData: {
        loading: false, hasMore: true
    },
    jobFilter: {},
    sortType: {},
    currentJob: null,
    currentJobMeta: null
}

const AuditionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ALL_JOB_LIST: {
            return {
                ...state,
                allJobList: action.payload
            }
        }
        case SET_ALL_JOB_LIST_META: {
            return {
                ...state,
                allJobListMetaData: action.payload
            }
        }
        case APPEND_ALL_JOB_LIST: {
            return {
                ...state,
                allJobList: [ ...state.allJobList, ...action.payload]
            }
        }
        case SET_SHORTLISTED_JOB_LIST: {
            return {
                ...state,
                shortlistedJobList: action.payload
            }
        }
        case SET_SHORTLISTED_JOB_LIST_META: {
            return {
                ...state,
                shortlistedJobListMetaData: action.payload
            }
        }
        case APPEND_SHORTLISTED_JOB_LIST: {
            return {
                ...state,
                shortlistedJobList: [ ...state.shortlistedJobList, ...action.payload]
            }
        }
        case SET_APPLIED_JOB_LIST: {
            return {
                ...state,
                appliedJobList: action.payload
            }
        }
        case SET_APPLIED_JOB_LIST_META: {
            return {
                ...state,
                appliedJobListMetaData: action.payload
            }
        }
        case APPEND_APPLIED_JOB_LIST: {
            return {
                ...state,
                appliedJobList: [ ...state.appliedJobList, ...action.payload]
            }
        }
        case SET_JOB_FILTER: {
            return {
                ...state,
                jobFilter: action.payload
            }
        }
        case SET_SORT_TYPE: {
            return {
                ...state,
                sortType: action.payload
            }
        }
        case SET_CURRENT_JOB: {
            return {
                ...state,
                currentJob: action.payload
            }
        }
        case SET_CURRENT_JOB_META: {
            return {
                ...state,
                currentJobMeta: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default AuditionReducer;